"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPRITESHEET_DELIMITER = exports.GATHER_LINK_SERVICE_PORT_DEV = exports.GATHER_LINK_SERVICE_PORT = exports.FORCE_STAGING_SPACES = exports.GATHER_OFFICE_ID = exports.GOKART_URL = exports.ESCAPE_ROOM_SPACE_NAME = exports.SCREEN_ANNOTATION_COLORS = exports.Platform = exports.Orientation = exports.IFRAME_WHITELIST_PREFIXES = exports.IframeErrors = exports.TutorialTaskIds = exports.validUserIDStartersForEmail = exports.ExploreTags = exports.VALID_SPACE_NAME_PATTERN = exports.MAX_EMAIL_DOMAINS_TO_ALLOW = exports.MAX_INVITE_EMAILS_TO_SEND = exports.VALID_EMAIL_DOMAIN_PATTERN = exports.VALID_EMAIL_PATTERN = exports.MAX_DESK_DESCRIPTION_LENGTH = exports.METAVERSE_ELLIPSE_MOBILE = exports.METAVERSE_ELLIPSE = exports.STARS_IMAGE_MOBILE = exports.THREE_STARS_IMAGE = exports.STARS_IMAGE = exports.NOTE_THROW_IMAGE = exports.COMPUTER_THROW_IMAGE = exports.MS_PER_DAY = exports.GATHER_EMAIL_DOMAIN = exports.MAX_SPACE_NAME_LENGTH = exports.MAX_LONG_LENGTH = exports.MAX_MEDIUM_LENGTH = exports.MAX_SHORT_LENGTH = exports.MAX_NAME_LENGTH = exports.INVITE_LINK_EXPIRATION_TIME = exports.MS_PER_HOUR = exports.InviteLinkExpirationTimes = exports.WHISPER_COLORS = exports.reservationTypes = exports.PRIVATE_AREA_COLORS = exports.objectSizes = exports.DEFAULT_OBJECT_DISTANCE = exports.FILTER_THRESHOLD = exports.VIDEO_THRESHOLD = exports.TELEPORT_INTERVAL = exports.STEP_INTERVAL = exports.MODIFIER = exports.SPEED = exports.directionMap = void 0;
exports.SendbirdMessageType = exports.CustomMessageType = exports.isOfficeChannelType = exports.isDmChannelType = exports.ChannelType = exports.ClientType = exports.GIFT_NORMALS = exports.GIFT_TEMPLATE_ID = exports.CONTACT_US_LINK = exports.CONTACT_US_PATH = exports.TERMS_OF_SERVICE_LINK = void 0;
exports.directionMap = {
    stand: 0,
    "down-1": 1,
    "down-2": 2,
    "up-1": 3,
    "up-2": 4,
    "left-1": 5,
    "left-2": 6,
    "right-1": 7,
    "right-2": 8,
    "dance-1": 9,
    "dance-2": 10,
    "dance-3": 11,
    "dance-4": 12,
};
exports.SPEED = 100;
exports.MODIFIER = 100;
exports.STEP_INTERVAL = 10;
exports.TELEPORT_INTERVAL = 50;
exports.VIDEO_THRESHOLD = 12;
exports.FILTER_THRESHOLD = 16;
exports.DEFAULT_OBJECT_DISTANCE = 3;
exports.objectSizes = 32;
exports.PRIVATE_AREA_COLORS = [
    "#d32f2f",
    "#c2185b",
    "#7b1fa2",
    "#512da8",
    "#303f9f",
    "#1976d2",
    "#0288d1",
    "#0097a7",
    "#00796b",
    "#388e3c",
    "#689f38",
    "#afb42b",
    "#ffd835",
    "#ffb300",
    "#fb8c00",
    "#f4511e",
];
exports.reservationTypes = {
    CLASSROOM: "classroom",
    CONFERENCE: "conference",
    PARTY: "party",
    REMOTE_WORK: "remote work",
    OTHER: "other",
};
exports.WHISPER_COLORS = new Set([
    "#FF9DDE",
    "#FBD54E",
    "#64E9D1",
    "#AEE964",
    "#A966FF",
    "#FC7079",
    "#FF9960",
    "#EA36AC",
    "#B67800",
    "#2D62EC",
    "#37C214",
    "#7230FF",
    "#D42E2E",
    "#E85110",
]);
var InviteLinkExpirationTimes;
(function (InviteLinkExpirationTimes) {
    InviteLinkExpirationTimes["ONE_MONTH"] = "1 month";
    InviteLinkExpirationTimes["SEVEN_DAYS"] = "7 days";
    InviteLinkExpirationTimes["ONE_DAY"] = "1 day";
    InviteLinkExpirationTimes["TWELVE_HOURS"] = "12 hours";
    InviteLinkExpirationTimes["SIX_HOURS"] = "6 hours";
    InviteLinkExpirationTimes["ONE_HOUR"] = "1 hour";
    InviteLinkExpirationTimes["NEVER"] = "Never";
})(InviteLinkExpirationTimes || (exports.InviteLinkExpirationTimes = InviteLinkExpirationTimes = {}));
exports.MS_PER_HOUR = 60 * 60 * 1000;
exports.INVITE_LINK_EXPIRATION_TIME = {
    [InviteLinkExpirationTimes.ONE_HOUR]: exports.MS_PER_HOUR,
    [InviteLinkExpirationTimes.SIX_HOURS]: 6 * exports.MS_PER_HOUR,
    [InviteLinkExpirationTimes.TWELVE_HOURS]: 12 * exports.MS_PER_HOUR,
    [InviteLinkExpirationTimes.ONE_DAY]: 24 * exports.MS_PER_HOUR,
    [InviteLinkExpirationTimes.SEVEN_DAYS]: 7 * 24 * exports.MS_PER_HOUR,
    [InviteLinkExpirationTimes.ONE_MONTH]: 30 * 24 * exports.MS_PER_HOUR,
    Never: Infinity,
};
exports.MAX_NAME_LENGTH = 50;
exports.MAX_SHORT_LENGTH = 100;
exports.MAX_MEDIUM_LENGTH = 500;
exports.MAX_LONG_LENGTH = 2000;
exports.MAX_SPACE_NAME_LENGTH = 25;
exports.GATHER_EMAIL_DOMAIN = "@gather.town";
exports.MS_PER_DAY = exports.MS_PER_HOUR * 24;
exports.COMPUTER_THROW_IMAGE = "/images/game/computer-throw.png";
exports.NOTE_THROW_IMAGE = "/images/game/note-throw.png";
exports.STARS_IMAGE = "/images/game/stars.png";
exports.THREE_STARS_IMAGE = "/images/game/three-stars.png";
exports.STARS_IMAGE_MOBILE = "/images/game/stars-mobile.png";
exports.METAVERSE_ELLIPSE = "/images/site/metaverse-ellipse.png";
exports.METAVERSE_ELLIPSE_MOBILE = "/images/site/metaverse-ellipse-mobile.png";
exports.MAX_DESK_DESCRIPTION_LENGTH = 500;
exports.VALID_EMAIL_PATTERN = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
exports.VALID_EMAIL_DOMAIN_PATTERN = /^(?=.{4,255}$)([a-zA-Z0-9_]([a-zA-Z0-9_-]{0,61}[a-zA-Z0-9_])?\.){1,126}[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]$/;
exports.MAX_INVITE_EMAILS_TO_SEND = 500;
exports.MAX_EMAIL_DOMAINS_TO_ALLOW = 100;
exports.VALID_SPACE_NAME_PATTERN = /^(?!\s*$)^[a-zA-Z0-9_-\s]+$/;
var ExploreTags;
(function (ExploreTags) {
    ExploreTags["Conference"] = "conference";
    ExploreTags["Social"] = "social";
    ExploreTags["Community"] = "community";
    ExploreTags["Coworking"] = "coworking";
    ExploreTags["Education"] = "education";
    ExploreTags["Entertainment"] = "entertainment";
    ExploreTags["Art"] = "art";
})(ExploreTags || (exports.ExploreTags = ExploreTags = {}));
exports.validUserIDStartersForEmail = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "e",
    "2",
    "m",
    "R",
    "T",
];
var TutorialTaskIds;
(function (TutorialTaskIds) {
    TutorialTaskIds["RW_ONBOARDING_V2_INTRO"] = "RW_ONBOARDING_V2_INTRO";
    TutorialTaskIds["RW_ONBOARDING_V2_CHOOSE"] = "RW_ONBOARDING_V2_CHOOSE";
    TutorialTaskIds["RW_ONBOARDING_V2_FOLLOW_TO_SOCIALS"] = "RW_ONBOARDING_V2_FOLLOW_TO_SOCIALS";
    TutorialTaskIds["RW_ONBOARDING_V2_FOLLOW_TO_DESKS"] = "RW_ONBOARDING_V2_FOLLOW_TO_DESKS";
    TutorialTaskIds["RW_ONBOARDING_V2_FOLLOW_TO_MEETINGS"] = "RW_ONBOARDING_V2_FOLLOW_TO_MEETINGS";
    TutorialTaskIds["RW_ONBOARDING_V2_SOCIALS"] = "RW_ONBOARDING_V2_SOCIALS";
    TutorialTaskIds["RW_ONBOARDING_V2_MEETINGS"] = "RW_ONBOARDING_V2_MEETINGS";
    TutorialTaskIds["RW_ONBOARDING_V2_DESKS"] = "RW_ONBOARDING_V2_DESKS";
    TutorialTaskIds["RW_PLAYGROUND_MOVE"] = "RW_PLAYGROUND_MOVE";
    TutorialTaskIds["RW_PLAYGROUND_EXPLORE_LOBBY"] = "RW_PLAYGROUND_EXPLORE_LOBBY";
    TutorialTaskIds["RW_PLAYGROUND_EXPLORE_QUAD"] = "RW_PLAYGROUND_EXPLORE_QUAD";
    TutorialTaskIds["RW_PLAYGROUND_GO_REC_ROOM"] = "RW_PLAYGROUND_GO_REC_ROOM";
    TutorialTaskIds["RW_PLAYGROUND_GO_REC_ROOM_GUEST"] = "RW_PLAYGROUND_GO_REC_ROOM_GUEST";
    TutorialTaskIds["RW_PLAYGROUND_GO_OFFICE"] = "RW_PLAYGROUND_GO_OFFICE";
})(TutorialTaskIds || (exports.TutorialTaskIds = TutorialTaskIds = {}));
var IframeErrors;
(function (IframeErrors) {
    IframeErrors["NONE"] = "none";
    IframeErrors["INVALID_URL"] = "invalid url";
    IframeErrors["IFRAME_FORBIDDEN"] = "iframe forbidden";
    IframeErrors["BAD_RESPONSE"] = "bad response";
    IframeErrors["HTTP"] = "http";
    IframeErrors["OTHER"] = "other";
    IframeErrors["NO_URL"] = "no url";
})(IframeErrors || (exports.IframeErrors = IframeErrors = {}));
exports.IFRAME_WHITELIST_PREFIXES = ["https://docs.google.com/"];
var Orientation;
(function (Orientation) {
    Orientation[Orientation["Down"] = 0] = "Down";
    Orientation[Orientation["Right"] = 1] = "Right";
    Orientation[Orientation["Up"] = 2] = "Up";
    Orientation[Orientation["Left"] = 3] = "Left";
})(Orientation || (exports.Orientation = Orientation = {}));
var Platform;
(function (Platform) {
    Platform["DesktopWeb"] = "desktop web";
    Platform["DesktopApp"] = "desktop app";
    Platform["MobileWeb"] = "mobile web";
    Platform["MobileiOS"] = "mobile ios";
    Platform["MobileAndroid"] = "mobile android";
})(Platform || (exports.Platform = Platform = {}));
exports.SCREEN_ANNOTATION_COLORS = [
    "#EA36AC",
    "#B67800",
    "#2D62EC",
    "#37C214",
    "#7230FF",
    "#D42E2E",
    "#E85110",
    "#FF9DDE",
    "#FBD54E",
    "#64E9D1",
    "#AEE964",
    "#A966FF",
    "#FC7079",
    "#FF9960",
];
exports.ESCAPE_ROOM_SPACE_NAME = "Escape The Island";
exports.GOKART_URL = "https://cdn.gather.town/storage.googleapis.com/v0/b/gather-town.appspot.com/o/manually-uploaded%2Fgokarts%2Fgokart-spritesheet-august-2023.png?alt=media&token=8b6bc4dd-d1f3-4176-ad06-293b57efcadf";
exports.GATHER_OFFICE_ID = "oxrhEtb3sV7VutbQ\\GatherOffice";
exports.FORCE_STAGING_SPACES = [
    exports.GATHER_OFFICE_ID,
    "49pW4GbwVoFECNAM\\livekit",
    "XM1QP7KknX5YqRzS\\gather-load-test-alasdair",
    "bQFQ4gBWQW4i8lkr\\gather-test-asuarez",
];
exports.GATHER_LINK_SERVICE_PORT = 48563;
exports.GATHER_LINK_SERVICE_PORT_DEV = 42413;
exports.SPRITESHEET_DELIMITER = ".";
exports.TERMS_OF_SERVICE_LINK = "https://www.gather.town/terms-of-service";
exports.CONTACT_US_PATH = "/contact";
exports.CONTACT_US_LINK = `https://www.gather.town${exports.CONTACT_US_PATH}`;
exports.GIFT_TEMPLATE_ID = "Note - sCd4usANUKyXQ1ZW2yxzt";
exports.GIFT_NORMALS = {
    sticky: "https://cdn.gather.town/v0/b/gather-town.appspot.com/o/remote-work%2Fgifts%2Fsticky_normal.png?alt=media&token=144a261a-7a60-4a83-9fc8-bfa8194fb5ae",
    balloon: "https://cdn.gather.town/v0/b/gather-town.appspot.com/o/remote-work%2Fgifts%2Fballoon_normal.png?alt=media&token=89a48b6d-9403-4436-a331-3c91c73b9e9d",
    greeting: "https://cdn.gather.town/v0/b/gather-town.appspot.com/o/remote-work%2Fgifts%2Fheart_sticky_normal.png?alt=media&token=9bea8c36-679b-4cd0-b321-f707a61eb0e9",
    cake: "https://cdn.gather.town/v0/b/gather-town.appspot.com/o/remote-work%2Fgifts%2Fcake_normal.png?alt=media&token=742580d4-185b-4f0d-838a-4e0e77d7419e",
    cakeslice: "https://cdn.gather.town/v0/b/gather-town.appspot.com/o/remote-work%2Fgifts%2Fcake_slice_normal.png?alt=media&token=d18046d7-d94d-47d8-a36c-35c2439798cb",
    champagne: "https://cdn.gather.town/v0/b/gather-town.appspot.com/o/remote-work%2Fgifts%2Fchampagne_normal.png?alt=media&token=56ed1bcd-fc1c-4eaa-b7ab-66b46aac7445",
};
var ClientType;
(function (ClientType) {
    ClientType["Default"] = "default";
    ClientType["Recorder"] = "recorder";
})(ClientType || (exports.ClientType = ClientType = {}));
var ChannelType;
(function (ChannelType) {
    ChannelType["Everyone"] = "Everyone";
    ChannelType["Nook"] = "Nook";
    ChannelType["DM"] = "DM";
    ChannelType["CanonicalDM"] = "CanonicalDM";
})(ChannelType || (exports.ChannelType = ChannelType = {}));
const isDmChannelType = (type) => type === ChannelType.DM || type === ChannelType.CanonicalDM;
exports.isDmChannelType = isDmChannelType;
const isOfficeChannelType = (type) => type === ChannelType.Everyone || type === ChannelType.Nook;
exports.isOfficeChannelType = isOfficeChannelType;
var CustomMessageType;
(function (CustomMessageType) {
    CustomMessageType["GiftReaction"] = "GiftReaction";
    CustomMessageType["ChannelInvitationSucceeded"] = "ChannelInvitationSucceeded";
    CustomMessageType["Tombstone"] = "Tombstone";
})(CustomMessageType || (exports.CustomMessageType = CustomMessageType = {}));
var SendbirdMessageType;
(function (SendbirdMessageType) {
    SendbirdMessageType["Text"] = "MESG";
    SendbirdMessageType["File"] = "FILE";
    SendbirdMessageType["Admin"] = "ADMM";
})(SendbirdMessageType || (exports.SendbirdMessageType = SendbirdMessageType = {}));
//# sourceMappingURL=constants.js.map